export const betaUserIds = [
  '599d89385e73e30052729ad2', // Test user
  '63ebbf589ca940002c7e1a19', // Infinity Main
  // Infinity Team Members
  '63ee63d8e7caf60020dec60e',
  '63977965ed770f0021254bee',
  '63fcdc65f5e4f2002d98796b',
  '63fe8dae73d2c40021a20c80',
  '63fe756fc4f6040021f7686d',
  '63fe709cad44eb002ddaa699',
  '640a1d31233fa6002dbd08b8',
  '63fe9ecc9707d9002c2a972b',
  '640607feed3290002c112ff1',
  '64066caa282be90021e76c3d',
  '6405c7034513011e53719eb2',
  '6405eec5c1970c21ae0c74dd',
  '640799893d67f4189b82a860',
  '6408d5641bc9d42160776822',
  '64051bc6ae06ed0021db49ab',
  '64499b5f3f2ff0002c1c0ebd',
  '64498019477fc1002c8fd030',
  '650383570b8a51002c3426d4'
];



// WEBPACK FOOTER //
// ./src/modules/account-navbar/betaUsers.js